<template>
  <a class="d-inline btn btn-primary py-2-and-half font-weight-bold btn-amio-orange fa-chevron-right"
     href=""
     @click="onClickContactUs"
     role="button">
    <slot></slot>
  </a>
</template>

<script>
  import analyticsMixin from '@/mixins/analytics.mixin'
  import 'vue-awesome/icons/angle-down'

  export default {
    mixins: [analyticsMixin],

    methods: {
      onClickContactUs: function () {
        this.trackContactUs()
        this.$router.push('contact-us')
      }
    }
  }
</script>

<style scoped>
.btn-menu {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF !important;
  border-radius: 0;
  border: none transparent;
}

.btn-menu:hover, .btn-menu:active {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
